import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
	UntypedFormBuilder,
	UntypedFormControl,
	UntypedFormGroup,
	ValidationErrors,
	ValidatorFn,
	Validators,
} from '@angular/forms';
import { LeaderUserService } from '@services/leader';
import { OrganizationService } from '@services/member';
import { LanguageService } from '@services/public';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { VALIDATIONS } from '../../../../../shared/constant/constants';

const PAGE_PATH = `pages.leader.dashboard.groupManagement.stepOne`;

@Component({
	selector: 'app-step-one',
	templateUrl: './step-one.component.html',
	styleUrls: ['./step-one.component.scss'],
})
export class StepOneComponent implements OnInit {
	stepOneForm: UntypedFormGroup;
	public settings = {};
	users: any;
	validationMessage = VALIDATIONS;
	form: UntypedFormGroup;
	status = true;
	isAddgroup: boolean;
	isFieldDisabled: boolean = false;
	isSubmitted: boolean = false;
	rowData: any;
	selectedItems: any;
	dropdownSettings: IDropdownSettings = {};
	userData: any;
	organizations: any;
	allUsers: any;
	// Page language.
	page: { [key: string]: string } = {};
	constructor(
		private fb: UntypedFormBuilder,
		public bsModalRef: BsModalRef,
		private orgSVC: OrganizationService,
		private _languageSvc: LanguageService,
		private _userSvc: LeaderUserService,
	) {
		this.form = fb.group({
			name: new UntypedFormControl(null, [
				Validators.required,
				Validators.maxLength(200),
				this.noWhitespaceValidator1,
			]),
			organizationUUID: new UntypedFormControl(null, [Validators.required]),
			startDate: new UntypedFormControl(null, [Validators.required]),
			endDate: new UntypedFormControl(null, [this.dateRangeValidator]),
			visibleToUserUUIDs: new UntypedFormControl(null),
			public: [false],
			isEnroll: [false],
		});
	}

	ngOnInit(): void {
		this._languageSvc.get([PAGE_PATH]).then((value) => {
			if (typeof value[PAGE_PATH] !== 'object' || value[PAGE_PATH] === null)
				return;
			this.page = value[PAGE_PATH];
			for (const key in this.page)
				this._languageSvc
					.template(this.page[key])
					.then((value) => (this.page[key] = value));
		});
		const orgUUID = localStorage.getItem('organizationUUID');
		this.dropdownSettings = {
			singleSelection: false,
			defaultOpen: false,
			idField: 'uuid',
			textField: 'name',
			selectAllText: this.page?.selectAll,
			unSelectAllText: this.page?.unselectAll,
			itemsShowLimit: 3,
		};

		this._userSvc.getUsers().subscribe((users) => {
			this.allUsers = users;
		});
		this.orgSVC.getOrganizationsAPI().subscribe((organization) => {
			this.organizations = organization.filter(
				(element) => element.createGroup === true,
			);
		});
	}

	private dateRangeValidator: ValidatorFn = (): {
		[key: string]: any;
	} | null => {
		let invalid = false;
		const startDate = this.form && this.form.get('startDate').value;
		const endDate = this.form && this.form.get('endDate').value;
		if (startDate && endDate) {
			invalid = new Date(startDate).valueOf() > new Date(endDate).valueOf();
		}
		return invalid ? { invalidRange: { startDate, endDate } } : null;
	};

	decline() {
		this.bsModalRef.hide();
	}
	noWhitespaceValidator1(control: UntypedFormControl): ValidationErrors | null {
		const isWhitespace = (control.value || '').trim().length === 0;
		return isWhitespace ? { whitespace: true } : null;
	}

	get f() {
		return this.form.controls;
	}

	stepOneSubmit() {
		this.isSubmitted = true;
		let usersArray: any = [];
		const startDate = new DatePipe('en-US').transform(
			this.form.value.startDate,
			'YYYY-MM-dd',
		);
		const enddate = new DatePipe('en-US').transform(
			this.form.value.endDate,
			'YYYY-MM-dd',
		);
		this.form.value.startDate = startDate;
		this.form.value.endDate = enddate;
		this.form.value.public = this.form.value.public ? true : false;
		if (this.form.value.visibleToUserUUIDs !== null) {
			this.form.value.visibleToUserUUIDs.map((user) => {
				usersArray.push(user.uuid);
			});
			this.form.value.visibleToUserUUIDs = usersArray;
		} else {
			this.form.value.visibleToUserUUIDs = [];
		}
		localStorage.setItem('groupDetails', JSON.stringify(this.form.value));
		if (this.form.invalid) {
			return;
		}
	}

	onSelectOrganization() {
		const organizationUUID = this.form.value.organizationUUID;
		this.userData = this.allUsers.filter(
			(user: any) => user.organizationUUID === organizationUUID,
		);
		this.form.controls['visibleToUserUUIDs'].setValue(null);
		localStorage.setItem(
			'groupOrganizationUUID',
			JSON.stringify(organizationUUID),
		);
	}

	public onFilterChange(item: any) {
		return;
	}
	public onDropDownClose(item: any) {
		return;
	}

	public onItemSelect(item: any) {
		return;
	}
	public onDeSelect(item: any) {
		return;
	}

	public onSelectAll(items: any) {
		return;
	}
	public onDeSelectAll(items: any) {
		return;
	}
}
